import { render, staticRenderFns } from "./blinki-input-txt.vue?vue&type=template&id=d18d6d84&scoped=true&"
import script from "./blinki-input-txt.vue?vue&type=script&lang=js&"
export * from "./blinki-input-txt.vue?vue&type=script&lang=js&"
import style0 from "./blinki-input-txt.vue?vue&type=style&index=0&id=d18d6d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18d6d84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d18d6d84')) {
      api.createRecord('d18d6d84', component.options)
    } else {
      api.reload('d18d6d84', component.options)
    }
    module.hot.accept("./blinki-input-txt.vue?vue&type=template&id=d18d6d84&scoped=true&", function () {
      api.rerender('d18d6d84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/template/form/blinki-input-txt.vue"
export default component.exports